import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch, useSelector } from 'react-redux';
import { setTheme } from '../../reducers/mainControls';

import { themeConfig } from '../../config/theme-config';
import { showLayer } from '../../utils/map/mapHelpers';

const ThemeSelector = ({ mobile }) => {
  const theme = useSelector(({ mainControls: { theme } }) => theme);
  const level = useSelector(({ mainControls: { level } }) => level);

  const dispatch = useDispatch();
  const handleChange = (e) => {
    dispatch(setTheme(e.target.value));
    showLayer({ theme: e.target.value, level });
  };

  const themeItems = Object.keys(themeConfig).map((theme) => <MenuItem key={theme} value={theme}>{theme}</MenuItem>);

  return (
    <Box sx={{ width: mobile ? '60%' : '30%' }}>
      <FormControl size="small" fullWidth>
        <FormLabel id="theme-select-label">Theme</FormLabel>
        <Select
          labelId="theme-select-label"
          id="theme-selector"
          value={theme}
          onChange={handleChange}
        >
          {themeItems}
        </Select>
      </FormControl>
    </Box>
  );
};

export default ThemeSelector;
